import { render, staticRenderFns } from "./warehouses-import.vue?vue&type=template&id=30ef9284&scoped=true"
import script from "./warehouses-import.vue?vue&type=script&lang=js"
export * from "./warehouses-import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ef9284",
  null
  
)

export default component.exports